import getLogger from './get-logger';

export default {
  getLogger,
};
